export const OptionMode = {
  NEW: 'NEW',
  NOT_CHANGED: 'NOT_CHANGED',
  UPDATED: 'UPDATED',
  DELETED: 'DELETED',
};
